// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_aside__JuMib {
    /*position: fixed;*/
    /*z-index: 180;*/
    /*height: 100vh !important;*/
    /*top: 0;*/
    /*left: 0;*/
    /*width: 115px;*/
    width: 100%;
    transition:
        width 0.2s,
        opacity 0.1s,
        background 0.2s;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
}

.styles_header__SBfPy {
    height: var(--header-height);
    background:
        linear-gradient(
            to bottom,
            #fbfbfb calc(var(--header-height) / 2),
            #f0f3f7 var(--header-height),
            transparent var(--header-height),
            transparent 100%
        ),
        linear-gradient(to right, transparent 50%, #fbfbfb 100%);
    opacity: 0;
    transition: opacity.4s;
}

.styles_aside__JuMib.styles_active__q9O8O .styles_header__SBfPy {
    opacity: 1;
}

.styles_body__pk2VH {
    background: #f4f4f4;
    position: relative;
    flex: 1 1;
    transition: background 0.2s;
}

.styles_aside__JuMib.styles_hidden__GLce3 {
    opacity: 0;
    pointer-events: none;
}

.styles_aside__JuMib.styles_active__q9O8O {
    /*width: 390px;*/
}

.styles_aside__JuMib.styles_active__q9O8O .styles_body__pk2VH {
    background: #f8f8f8;
}

.styles_logo__7SgCI {
    position: absolute;
    top: 53px;
    left: 104px;
}

.styles_infoTop__D-IPs {
    width: 100%;
    margin-bottom: 20px;

    /*position: absolute;*/
    /*top: 152px;*/
    /*margin: 12px 48px 60px;*/
}

.styles_info__3\\+eA9 {
    /*margin-left: 71px;*/
    height: 100%;
    padding: 0 20px;
}

.styles_info__3\\+eA9.styles_hidden__GLce3 {
    opacity: 0;
    transition: opacity 0.2s;
}

.styles_icons__DUbo\\+ {
    --icon-fill-color-custom: #1650b4;
    --icon-color-custom: var(--light-grey);
    margin-top: 244px;
    padding-left: 39px;
    display: flex;
    flex-direction: column;
    grid-gap: 26px;
    cursor: pointer;
}

/*.icons > *:not(:last-child) {*/
/*    --icon-fill-color-custom: transparent;*/
/*}*/

/*.icons > :last-child {*/
/*    --icon-color-custom: var(--light-grey);*/
/*}*/

/*.icons > * {*/
/*    width: 25px;*/
/*}*/

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_infoSingle__3MfWD {
        display: none;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    /*.aside.active {*/
    /*    width: 350px;*/
    /*    background:*/
    /*        linear-gradient(*/
    /*            to bottom,*/
    /*            #fbfbfb calc(var(--header-height) / 2),*/
    /*            #f0f3f7 var(--header-height),*/
    /*            transparent var(--header-height),*/
    /*            transparent 100%*/
    /*        ),*/
    /*        linear-gradient(to right, transparent 50%, #fbfbfb 100%);*/
    /*}*/

    .styles_aside__JuMib.styles_active__q9O8O header {
        background: transparent;
    }

    .styles_logo__7SgCI {
        top: 43.5px;
    }

    .styles_infoTop__D-IPs {
        /*top: 120px;*/
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectionMenuBase/styles.module.css"],"names":[],"mappings":"AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX;;;uBAGmB;IACnB,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B;;;;;;;;gEAQ4D;IAC5D,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;;IAEnB,sBAAsB;IACtB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,eAAe;AACnB;;AAEA,gCAAgC;AAChC,6CAA6C;AAC7C,IAAI;;AAEJ,yBAAyB;AACzB,8CAA8C;AAC9C,IAAI;;AAEJ,eAAe;AACf,mBAAmB;AACnB,IAAI;;AAEJ;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB,sDAAsD;IACtD,4CAA4C;IAC5C,gDAAgD;IAChD,+BAA+B;IAC/B,aAAa;IACb,oEAAoE;IACpE,IAAI;;IAEJ;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.aside {\n    /*position: fixed;*/\n    /*z-index: 180;*/\n    /*height: 100vh !important;*/\n    /*top: 0;*/\n    /*left: 0;*/\n    /*width: 115px;*/\n    width: 100%;\n    transition:\n        width 0.2s,\n        opacity 0.1s,\n        background 0.2s;\n    display: flex;\n    flex-direction: column;\n    padding: 0 20px;\n}\n\n.header {\n    height: var(--header-height);\n    background:\n        linear-gradient(\n            to bottom,\n            #fbfbfb calc(var(--header-height) / 2),\n            #f0f3f7 var(--header-height),\n            transparent var(--header-height),\n            transparent 100%\n        ),\n        linear-gradient(to right, transparent 50%, #fbfbfb 100%);\n    opacity: 0;\n    transition: opacity.4s;\n}\n\n.aside.active .header {\n    opacity: 1;\n}\n\n.body {\n    background: #f4f4f4;\n    position: relative;\n    flex: 1;\n    transition: background 0.2s;\n}\n\n.aside.hidden {\n    opacity: 0;\n    pointer-events: none;\n}\n\n.aside.active {\n    /*width: 390px;*/\n}\n\n.aside.active .body {\n    background: #f8f8f8;\n}\n\n.logo {\n    position: absolute;\n    top: 53px;\n    left: 104px;\n}\n\n.infoTop {\n    width: 100%;\n    margin-bottom: 20px;\n\n    /*position: absolute;*/\n    /*top: 152px;*/\n    /*margin: 12px 48px 60px;*/\n}\n\n.info {\n    /*margin-left: 71px;*/\n    height: 100%;\n    padding: 0 20px;\n}\n\n.info.hidden {\n    opacity: 0;\n    transition: opacity 0.2s;\n}\n\n.icons {\n    --icon-fill-color-custom: #1650b4;\n    --icon-color-custom: var(--light-grey);\n    margin-top: 244px;\n    padding-left: 39px;\n    display: flex;\n    flex-direction: column;\n    grid-gap: 26px;\n    cursor: pointer;\n}\n\n/*.icons > *:not(:last-child) {*/\n/*    --icon-fill-color-custom: transparent;*/\n/*}*/\n\n/*.icons > :last-child {*/\n/*    --icon-color-custom: var(--light-grey);*/\n/*}*/\n\n/*.icons > * {*/\n/*    width: 25px;*/\n/*}*/\n\n@media screen-md-max {\n    .infoSingle {\n        display: none;\n    }\n}\n\n@media screen-md-max {\n    /*.aside.active {*/\n    /*    width: 350px;*/\n    /*    background:*/\n    /*        linear-gradient(*/\n    /*            to bottom,*/\n    /*            #fbfbfb calc(var(--header-height) / 2),*/\n    /*            #f0f3f7 var(--header-height),*/\n    /*            transparent var(--header-height),*/\n    /*            transparent 100%*/\n    /*        ),*/\n    /*        linear-gradient(to right, transparent 50%, #fbfbfb 100%);*/\n    /*}*/\n\n    .aside.active header {\n        background: transparent;\n    }\n\n    .logo {\n        top: 43.5px;\n    }\n\n    .infoTop {\n        /*top: 120px;*/\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"aside": `styles_aside__JuMib`,
	"header": `styles_header__SBfPy`,
	"active": `styles_active__q9O8O`,
	"body": `styles_body__pk2VH`,
	"hidden": `styles_hidden__GLce3`,
	"logo": `styles_logo__7SgCI`,
	"infoTop": `styles_infoTop__D-IPs`,
	"info": `styles_info__3+eA9`,
	"icons": `styles_icons__DUbo+`,
	"infoSingle": `styles_infoSingle__3MfWD`
};
export default ___CSS_LOADER_EXPORT___;
